<!-- @format -->

<template>
	<div :class="['name-drop-zone', `name-drop-zone--${variant}`]">
		<div class="name-drop-zone__label">{{ label }}</div>
		<div
			:class="[
				'name-drop-zone__zone',
				{ 'name-drop-zone__zone--empty': modelValue.length === 0 },
			]"
		>
			<CoreSortableList
				:modelValue="modelValue"
				:group="group"
				class="name-drop-zone__list"
				@update:modelValue="$emit('update:modelValue', $event)"
			>
				<NameChip
					v-for="(token, i) in modelValue"
					:key="`${i}-${token}`"
					:token="token"
				/>
			</CoreSortableList>
			<div
				v-if="variant === 'bordered' && modelValue.length === 0"
				class="name-drop-zone__placeholder"
			>
				{{ placeholder }}
			</div>
		</div>
	</div>
</template>

<script>
import CoreSortableList from '@/components/core/CoreSortableList.vue'
import NameChip from './NameChip.vue'

export default {
	name: 'NameDropZone',

	components: {
		CoreSortableList,
		NameChip,
	},

	props: {
		label: {
			type: String,
			required: true,
		},
		modelValue: {
			type: Array,
			required: true,
		},
		group: {
			type: [String, Object],
			required: true,
		},
		placeholder: {
			type: String,
			default: '',
		},
		variant: {
			type: String,
			default: 'bordered',
			validator: (v) => ['bordered', 'bare'].includes(v),
		},
	},

	emits: ['update:modelValue'],
}
</script>

<style scoped>
.name-drop-zone {
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
}

.name-drop-zone__label {
	text-transform: uppercase;
	letter-spacing: 0.06em;
	font-size: 1.1rem;
	font-weight: 600;
	color: var(--color-primary-700, #1aa176);
}

.name-drop-zone--bordered .name-drop-zone__label {
	color: var(--color-neutral-900, #1a1f2c);
}

.name-drop-zone__zone {
	position: relative;
}

.name-drop-zone--bordered .name-drop-zone__zone {
	min-height: 7rem;
	padding: 1rem;
	border: 2px dashed var(--color-primary-300, #c7f6de);
	border-radius: 10px;
	background: transparent;
}

.name-drop-zone--bare .name-drop-zone__zone {
	min-height: 5.5rem;
}

.name-drop-zone__placeholder {
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--color-neutral-900, #b0b4bd);
	font-size: 1.4rem;
	font-style: italic;
	pointer-events: none;
}

.name-drop-zone__list {
	min-height: 4rem;
}
</style>
